export const getFormattedPrice = ({locale, price, currency}) => {
  const numberFormat = new Intl.NumberFormat(locale, {style: 'currency', currency});
  return numberFormat.format(price);
};



// WEBPACK FOOTER //
// ./utils/currency-helper.ts